import * as React from "react";

import { Icon } from "../../Icons/Icon";

import { Circle, PositionAdjustBlock } from "./Arrows.styles";

export function ArrowLeft(): JSX.Element {
    return (
        <Circle>
            <PositionAdjustBlock>
                <Icon name="ArrowCLeftIcon" size={34} />
            </PositionAdjustBlock>
        </Circle>
    );
}
